import FormReportComp from '../../Components/FormComp/FormReport';
import Navigation from '../../Components/Navigation/Navigation';
import Footer from '../../Components/Footer/Footer';
import './form.css';

const FormPage = () => {
  return (
    <>
      <Navigation />
      <FormReportComp />
      <Footer />
    </>
  );
};

export default FormPage;